<template>
  <div class="room-header">
    <div class="user-info">
      <div class="avatar" v-if="avatar">
        <img :src="avatar" :alt="username">
      </div>
      <div class="avatar" v-else>
        <span>{{ username ? username.charAt(0).toUpperCase() : 'U' }}</span>
      </div>
      <span class="username">{{ username || '未知用户' }}</span>
      <div class="connection-wrapper">
        <span class="connection-status" :class="{ 'connected': isConnected }"></span>
        <button v-if="!isConnected" class="reconnect-btn" @click="$emit('reconnect')">重新连接</button>
      </div>
      <el-button
          class="settings-btn"
          type="text"
          @click="showSettings = true"
      >
        <i class="el-icon-setting"></i>
      </el-button>
    </div>
    <settings-dialog
        :visible.sync="showSettings"
    />
  </div>
</template>

<script>
import SettingsDialog from './SettingsDialog.vue'

export default {
  name: 'RoomsHeader',

  components: {
    SettingsDialog
  },

  data() {
    return {
      showSettings: false
    }
  },

  props: {
    avatar: {
      default: null
    },
    username: {
      default: ''
    },
    isConnected: {
      default: false
    }
  },

  emits: ['reconnect']
}
</script>

<style scoped>
.room-header {
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar span {
  color: #666;
  font-size: 16px;
  font-weight: 500;
}

.username {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.connection-status {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff4d4f; /* 红色表示未连接 */
  transition: background-color 0.3s ease;
}

.connection-status.connected {
  background-color: #52c41a; /* 绿色表示已连接 */
}

.connection-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.reconnect-btn {
  padding: 4px 8px;
  font-size: 12px;
  color: #fff;
  background-color: #1890ff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.reconnect-btn:hover {
  background-color: #40a9ff;
}

.reconnect-btn:active {
  background-color: #096dd9;
}

.settings-btn {
  padding: 4px;
  font-size: 16px;
  color: #666;
  margin-left: auto;
}

.settings-btn:hover {
  color: #1890ff;
}
</style>
